import { render, staticRenderFns } from "./modalOsEditarObs.vue?vue&type=template&id=074a4acd"
import script from "./modalOsEditarObs.vue?vue&type=script&lang=js"
export * from "./modalOsEditarObs.vue?vue&type=script&lang=js"
import style0 from "./modalOsEditarObs.vue?vue&type=style&index=0&id=074a4acd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports